import { bookServiceApi } from '@/services/api';

export interface TimelineEvent {
  event_id: number;
  event_title: string;
  event_description: string;
  event_order: number;
}

export interface TimelineSection {
  section_id: number;
  section_title: string;
  section_number: number;
  chapter_number: number;
  status: 'unlocked' | 'locked' | string;
  events: TimelineEvent[];
}

export interface TimelineEventsResponse {
  data: {
    sections: TimelineSection[];
  };
  is_premium: boolean;
}

export const getTimelineEvents = async (bookId: number, isSpoil = false): Promise<TimelineEventsResponse> => {
  const res = await bookServiceApi.get<TimelineEventsResponse>(`/novel/books/${bookId}/timeline-events?is_spoil=${isSpoil}`);
  if (res.success && res.data) {
    return res.data;
  }
  throw new Error(res.error || 'Failed to fetch timeline events');
};
